// Add your custom JS here.

/* Meny on scroll */
document.addEventListener("DOMContentLoaded", function() {
    var navbar = document.getElementById("wrapper-navbar");

    function checkScroll() {
        if (window.scrollY > 10) {
            navbar.classList.add("scrolled");
        } else {
            navbar.classList.remove("scrolled");
        }
    }

    // Initial check upon page load
    checkScroll();

    // Check on scroll
    window.addEventListener("scroll", checkScroll);
});

// Animated txt
document.addEventListener('DOMContentLoaded', function () {
    var fancyTextElement = document.querySelector(".fancy-txt p.txt-inner");
    if (fancyTextElement) {
        var textContent = fancyTextElement.textContent.trim();
        var stringsArray = textContent.split('|');

        // Tøm bare innholdet innenfor <p> for animasjon
        fancyTextElement.textContent = "";

        new Typed(fancyTextElement, {
            strings: stringsArray,
            typeSpeed: 60,
            backSpeed: 50,
            backDelay: 2000,
            startDelay: 900,
            loop: true,
            showCursor: true,
            cursorChar: '|',
            onBegin: function() {
                fancyTextElement.style.visibility = "visible";
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const nedtellingHeadings = document.querySelectorAll('.nedtelling');
    if (!nedtellingHeadings.length) return; // Avslutt hvis ingen elementer finnes

    const duration = 1000;

    const animateCounter = (element, endValue) => {
        const startValue = 0;
        const increment = endValue / (duration / 16); // Antall steg per frame
        let currentValue = startValue;

        const updateCounter = () => {
            currentValue += increment;
            if (currentValue < endValue) {
                element.textContent = endValue % 1 === 0
                    ? Math.floor(currentValue).toLocaleString('de-DE')
                    : currentValue.toFixed(1).replace('.', ',').toLocaleString('de-DE');
                requestAnimationFrame(updateCounter);
            } else {
                element.textContent = endValue.toLocaleString('de-DE'); // Sett endelig verdi
            }
        };

        updateCounter();
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                nedtellingHeadings.forEach(heading => {
                    const rawValue = heading.textContent.trim();
                    const endValue = parseFloat(rawValue.replace(/\./g, '')); // Fjern punktum

                    animateCounter(heading, endValue);
                });
                observer.disconnect(); // Stopp observering etter animasjon
            }
        });
    }, { threshold: 0.1 });

    nedtellingHeadings.forEach(heading => observer.observe(heading));
});

// Sustainability
document.addEventListener('click', (e) => {
    const btn = e.target.closest('.sus-toggle');
    if (!btn) return;
    const item = btn.closest('.company-item');
    const list = btn.closest('.js-sus-list');
    const full = item.querySelector('.sus-full');
    const prev = item.querySelector('.sus-preview');

    // Lukk alle andre
    list.querySelectorAll('.company-item.expanded').forEach(el => {
        if (el === item) return;
        el.classList.remove('expanded');
        el.querySelector('.sus-full').hidden = true;
        el.querySelector('.sus-preview').hidden = false;
        const b = el.querySelector('.sus-toggle');
        if (b) b.setAttribute('aria-expanded','false');
    });

    // Toggle gjeldende
    const open = !item.classList.contains('expanded');
    item.classList.toggle('expanded', open);
    full.hidden = !open;
    prev.hidden = open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
});